module.exports = __webpack_public_path__ + "img/step5-c.f7a51552.png";